import React from 'react';
import ReactDOM from 'react-dom';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { Router } from 'react-router-dom';
import '@guestyci/foundation/style/styles.css';
import createHistory from '@guestyci/history/createHistory';

import queryClient from 'utils/queryClient';
import DeviceDetectionContainer from './app/module/DeviceDetectionContainer';
import MobileComponent from './app/module/DeviceDetectionContainer/MobileComponent';

import App from './app/App';
import EnvIndicator from './app/shareable/EnvIndicator';

const history = createHistory({ baseUrl: '', isFragment: false });

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <EnvIndicator />
      <ReactQueryDevtools />
      <Router history={history}>
        <DeviceDetectionContainer
          mobile={<MobileComponent />}
          desktop={<App />}
        />
      </Router>
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
